<template>
  <HeaderBase>
    <div
      class="flex items-center shrink header-title w-1/5 cursor-pointer"
      @click="$router.push({
        name: 'services.categories',
      })">
      <span class="arrow arrow-l arrow-primary"></span>
      <b>Категория: {{ $delve(category, 'name') }}</b>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapState({
      categories: (state) => state.services.categories,
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    category() {
      return this.categories.find((el) => el.id === this.id);
    },
  },
};
</script>
